
import { ReactNode } from "react";
import { ChevronRight } from "lucide-react";

interface SituationCardProps {
  icon: ReactNode;
  text: ReactNode;
  onClick: () => void;
  isHighlighted?: boolean;
}

const SituationCard = ({ icon, text, onClick, isHighlighted = false }: SituationCardProps) => {
  if (isHighlighted) {
    return (
      <div className="relative bg-gradient-to-r from-[#D3E4FD] to-[#F1F0FB] py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6">
        <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
            {icon}
          </div>
        </div>
        <p className="text-base md:text-lg text-[#222222] pl-4 text-left">
          {text}
        </p>
      </div>
    );
  }

  return (
    <div 
      className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6 cursor-pointer transition-all hover:bg-white/20"
      onClick={onClick}
    >
      <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
          {icon}
        </div>
      </div>
      <p className="text-base md:text-lg text-white pl-4 text-left">
        {text}
      </p>
      <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center animate-horizontal-bounce">
        <ChevronRight className="w-4 h-4 text-white" />
        <ChevronRight className="w-4 h-4 text-white -ml-2" />
      </div>
    </div>
  );
};

export default SituationCard;
